import React from "react";

import { SelectEntityByType } from "../../modules/SelectEntityByType/SelectEntityByType";
import { FiltersFieldsTypes } from "../../modules/SelectEntityByType/constants";

export const TemplateSelectorsSourceField = ({ className, name = "source_code", label = "Source", ...restProps }) => (
    <SelectEntityByType
        className={className}
        name={name}
        FieldsTypes={FiltersFieldsTypes.templateSelectorSource}
        label={label}
        {...restProps}
    />
);
